/*** IMPORTS FROM imports-loader ***/
var define = false;

import each from 'lodash/each'
import $ from 'jquery'
import Vue from 'vue'
import eventBus from './eventBus'

function setupGalleries(container) {
  const anchors = container.querySelectorAll('a[href^="#lightbox-"]')
  if (anchors.length) {
    each(anchors, (anchor) => {
      const $anchor = $(anchor)
      const galleryId = $anchor.attr('href')

      $anchor.on('click', (ev) => {
        ev.preventDefault()
        ev.stopPropagation()
        eventBus.$emit('open-lightbox', galleryId)
      })
    })
  }

  const galleries = container.querySelectorAll('.cms-photo-gallery')
  if (galleries.length) {
    each(galleries, (el) => {
      new Vue({ el })
    })
  }
}

/**
 * Set up photo galleries in the container.
 *
 * @param {HTMLElement} container
 */
function setupPhotoGalleries(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  setupGalleries(container)

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return
        }

        setupGalleries(node)
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

// eslint-disable-next-line import/prefer-default-export
export { setupPhotoGalleries }

